module.exports = __webpack_public_path__ + "static/img/es-MX.362f83fe.svg";